<div class="container-fluid">
  <div class="page-container" [class.panel-open]="isEditPanelOpen">
    <div class="header-container">
      <div class="left-section">
        <div class="tags-container" data-tour="module-tags">
          <nb-tag-list (tagRemove)="onTagRemove($event)">
            @for (tag of selectedTags; track tag.id) {
              <nb-tag [text]="tag.value" removable (remove)="onTagRemove(tag)"></nb-tag>
            }
            <input type="text" nbTagInput (tagAdd)="onTagAdd($event)" (input)="onTagInputChange($event)" [nbAutocomplete]="auto" #tagInput fullWidth placeholder="Saisir des balises puis appuyer sur entrée...">
          </nb-tag-list>

          <nb-autocomplete #auto (selectedChange)="onTagSelected($event, tagInput)">
            @for (option of filteredTags; track option.id) {
              <nb-option [value]="option">
                {{ option.value }}
              </nb-option>
            }
          </nb-autocomplete>
        </div>
      </div>
      <div class="right-section">
        <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="onSearchTermChange($event)"
          placeholder="Rechercher par nom" class="search-input" data-tour="module-search">
        <select [(ngModel)]="displayMode" (change)="onDisplayModeChange()" class="form-select select-color" data-tour="module-display-mode">
          <option value="grid">Grille</option>
          <option value="smallGrid">Petite grille</option>
          <option value="list">Liste</option>
        </select>
        <button nbButton ghost size="small" class="ms-2 tour-help-btn"
            (click)="startTour()" title="Aide">
            <i class="bi bi-question-circle"></i>
        </button>
      </div>
    </div>
    <span class="fil-ariane">
      <h6><strong>Mes Modules</strong></h6>
    </span>
    <div class="content-area" [class.panel-open]="isEditPanelOpen">
    <div class="grid-container">

      @if (loading) {
      <div class="folder-loading">
        <nb-spinner size="small"></nb-spinner> Chargement des modules...
      </div>
      }

      <div class="campaign-grid" data-tour="module-grid"
        [ngClass]="{'small-grid': displayMode === 'smallGrid', 'list-view': displayMode === 'list'}">
        
        @if (displayMode === 'list') {
          <div class="campaign-menu">
            <div class="campaign-item-details">
              <div class="campaign-title"><strong>Nom</strong></div>
                </div>
          </div>
        }

        @for (module of filteredModules; track module.id) {
        <div class="campaign-item" (click)="openEditPanel(module)" [class.active]="editingModule?.id === module.id" [attr.data-tour]="$first ? 'module-card' : null">
          @if (module.icon) {
          <div class="image-container">
            <!-- Assuming icon URL is directly usable -->
            <img [src]="module.icon" alt="{{module.name}}" class="campaign-image">
          </div>
          } @else {
          <div class="image-container">
            <div class="campaign-image placeholder"></div>
          </div>
          }
          <div class="campaign-item-details">
            <div class="campaign-title" title="{{ module.name }}">{{ module.name }}</div>
          </div>
          <!-- No context menu -->
        </div>
        }
        @empty {
          @if (!loading) {
            <div class="no-modules">Aucun module trouvé.</div>
          }
        }
      </div>

      <!-- Sentinel element for infinite scroll - Intersection Observer watches this -->
      <div #sentinel class="scroll-sentinel"></div>

      <!-- Loading indicator for infinite scroll -->
      @if (loadingMore) {
        <div class="folder-loading">
          <nb-spinner size="small"></nb-spinner> Chargement de plus de modules...
        </div>
      }

      <!-- End of list indicator -->
      @if (!loading && !loadingMore && modules.length >= totalModules && totalModules > 0) {
        <div class="folder-loading">
          Tous les modules ont été chargés ({{ totalModules }} modules)
        </div>
      }
    </div>

    @if (isEditPanelOpen && editingModule) {
      <div class="side-panel">
        <app-module-menu
          [moduleToEdit]="editingModule"
          [screenshotUrl]="editingModule.icon"
          [isEditMode]="true"
          [availableTags]="stripoTags"
          (close)="closeEditPanel()"
          (openInEditor)="openModuleInEditor($event)"
          (update)="onModuleUpdate($event)"
          (delete)="onModuleDelete()">
        </app-module-menu>
      </div>
    }
    </div>
  </div>
</div>

<ng-template #deleteModuleDialog let-ref="dialogRef">
  <nb-card>
    <nb-card-body>Êtes-vous sûr de vouloir supprimer le module "<strong>{{ editingModule?.name }}</strong>" ?</nb-card-body>
    <nb-card-footer>
      <div class="row">
        <div class="col text-center">
          <button nbButton status="success" (click)="confirmDeleteModule(ref)">Oui</button>
        </div>
        <div class="col text-center">
          <button nbButton status="danger" (click)="ref.close()">Non</button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>
